module.exports = __webpack_public_path__ + "img/r-logo-light.dc3b1736.svg";